import { Link } from '@mui/material';
import { CerebroHeading, CerebroText } from '../../shared/components';

export const NdaText = () => {
	return (
		<>
			<CerebroHeading size="h3" gutterBottom>
				Confidentiality
			</CerebroHeading>

			<CerebroText variant="small" gutterBottom>
				This Confidentiality Agreement (the <strong>&quot;Agreement&quot;</strong>
				), dated as of the last date set forth beneath each signature below (
				<strong>&quot;Effective Date&quot;</strong>
				), is between Cerebro Capital, a Delaware corporation (the <strong>&quot;Company&quot;</strong>
				), and the individual or entity set forth in the signature line below (each, a{' '}
				<strong>&quot;Party&quot;</strong> and, collectively, the
				<strong>&quot;Parties&quot;</strong>
				).
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				1. <strong style={{ textDecoration: 'underline' }}>Use; Disclosure; Obligation to Safeguard.</strong>{' '}
				(a) In connection with exploring a potential business relationship between the Parties (the{' '}
				<strong>&quot;Purpose&quot;</strong>
				), either Party (<strong>&quot;Disclosing Party&quot;</strong>) may disclose Confidential Information
				(as defined below) to the other Party (<strong>&quot;Recipient&quot;</strong>
				). Recipient shall use the Confidential Information solely for the Purpose and, subject to Section 3,
				shall not disclose such Confidential Information other than to its employees, officers, directors,
				directors, service providers, attorneys, accountants and advisors (collectively,
				<strong>&quot;Representatives&quot;</strong>) who: (a) need access to such Confidential Information for
				the Purpose; (b) are informed of its confidential nature; and (c) are bound by written confidentiality
				obligations no less protective of the Confidential Information than the terms contained herein.
				Recipient shall safeguard the Confidential Information from unauthorized use, access or disclosure using
				a commercially reasonable degree of care in the industry in which the Recipient operates or the degree
				of care used to protect the Recipient&apos;s own confidential and proprietary information, whichever
				provides a higher degree of care. Recipient shall promptly notify the Disclosing Party of any
				unauthorized use or disclosure of Confidential Information and take all reasonable steps and cooperate
				with the Disclosing Party to prevent further use or disclosure. Recipient shall be responsible for any
				breach of this Agreement caused by its Representatives. (b) Should the Parties decide to pursue a
				business relationship, any subsequent agreement executed or acknowledged by the Parties that sets forth
				the confidentiality obligations specific to that relationship shall supersede the terms of this
				Agreement, which shall immediately cease to be of any force or effect.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				2. <strong style={{ textDecoration: 'underline' }}>Definition.</strong>{' '}
				<strong>&quot;Confidential Information&quot;</strong> means all non-public, proprietary, or confidential
				information of or relating to Disclosing Party or its business in oral, visual, written, electronic, or
				other tangible or intangible form, whether or not marked or designated as{' '}
				<strong>&quot;confidential,&quot;</strong> and all notes, analyses, summaries, and other materials
				prepared by Recipient or any of its Representatives that contain, are based on, or otherwise reflect, to
				any degree, any of the foregoing (<strong>&quot;Notes&quot;</strong>
				); provided, however, that Confidential Information does not include any information that: (a) is or
				becomes generally available to the public other than as a result of Recipient&apos;s or its
				Representatives&apos; act or omission; (b) is obtained by Recipient or its Representatives on a
				non-confidential basis from a third party that was not legally or contractually restricted from
				disclosing such information; (c) was in Recipient&apos;s or its Representatives&apos; possession, as
				established by documentary evidence, before Disclosing Party&apos;s disclosure hereunder; or (d) was or
				is independently developed by Recipient or its Representatives, as established by documentary evidence,
				without using any Confidential Information. Confidential Information also includes: (x) the facts that
				the parties are in discussions regarding the Purpose and that Confidential Information has been
				disclosed; and (y) any terms, conditions or arrangements discussed.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				3. <strong style={{ textDecoration: 'underline' }}>Compelled Disclosure.</strong> If Recipient or any of
				its Representatives is required by applicable law or a valid legal order to disclose any Confidential
				Information, Recipient shall notify Disclosing Party of such requirements so that Disclosing Party may
				seek, at Disclosing Party&apos;s expense, a protective order or other remedy, and Recipient shall
				reasonably assist Disclosing Party therewith. If Recipient remains legally compelled to make such
				disclosure, it shall: (a) only disclose that portion of the Confidential Information that it is required
				to disclose; and (b) use reasonable efforts to ensure that such Confidential Information is afforded
				confidential treatment.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				4.{' '}
				<strong style={{ textDecoration: 'underline' }}>
					Return and Destruction of Confidential Information.
				</strong>{' '}
				Recipient shall, at Disclosing Party&apos;s request, promptly return to Disclosing Party or destroy all
				Confidential Information in its and its Representatives&apos; possession (including by deleting any
				digital files that contain Confidential Information, and, at Disclosing Party&apos;s request, certify in
				writing the destruction of such Confidential Information; provided, however, that Recipient may retain
				copies of Confidential Information as required by applicable law or Recipient&apos;s document retention
				policies, but such Confidential Information shall remain subject to the terms and conditions of this
				Agreement, which shall survive indefinitely with respect to such Confidential Information). Recipient
				shall continue to be bound by the terms and conditions of this Agreement with respect to such retained
				Confidential Information regardless of the termination of this Agreement.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				5. <strong style={{ textDecoration: 'underline' }}>Disclaimers.</strong> This Agreement imposes no
				obligation on either Party to disclose any Confidential Information or to negotiate for, enter into, or
				otherwise pursue the Purpose.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				6. <strong style={{ textDecoration: 'underline' }}>Intellectual Property.</strong> Disclosing Party
				retains its entire right, title, and interest in and to all Confidential Information, and no disclosure
				of Confidential Information hereunder will be construed as a license, assignment, or other transfer of
				any such right, title, and interest to Recipient or any other person.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				7. <strong style={{ textDecoration: 'underline' }}>Termination.</strong> Except as set forth in Sections
				1(b) or 4, the rights and obligations of the parties under this Agreement expire two years after the
				Effective Date; provided that with respect to Confidential Information that is a trade secret under the
				laws of any jurisdiction, such rights and obligations will survive such expiration until, if ever, such
				Confidential Information loses its trade secret protection other than due to an act or omission of
				Recipient or its Representatives.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				8. <strong style={{ textDecoration: 'underline' }}>Equitable Relief.</strong> Recipient acknowledges and
				agrees that any breach of this Agreement will cause injury to Disclosing Party for which money damages
				would be an inadequate remedy and that, in addition to remedies at law, Disclosing Party is entitled to
				equitable relief as a remedy for any such breach.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				9. <strong style={{ textDecoration: 'underline' }}>Governing Law; Submission to Jurisdiction.</strong>{' '}
				This Agreement is governed by and construed in accordance with the internal laws of the State of
				Delaware without giving effect to any choice or conflict of law provision or rule that would require or
				permit the application of the laws of any jurisdiction other than those of the State of Delaware. Any
				legal suit, action, or proceeding arising out of or related to this Agreement will be instituted
				exclusively in the federal courts of the United States or the courts of the State of Delaware, and each
				Party irrevocably submits to the exclusive jurisdiction of such courts in any such suit, action, or
				proceeding.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				10. <strong style={{ textDecoration: 'underline' }}>Notices.</strong> All notices, requests, consents,
				claims, demands, waivers, and other communications hereunder (each, a{' '}
				<strong>&quot;Notice&quot;</strong>) must be in writing and addressed to the relevant party at such
				address that may be designated by the party giving Notice in accordance with this Section). All Notices
				may be delivered by personal delivery, nationally recognized overnight courier (with all fees prepaid),
				facsimile or email (with confirmation of transmission) or certified or registered mail (in each case,
				return receipt requested, postage pre-paid), in which case a Notice is effective upon delivery to the
				receiving party. Notices from Disclosing Party to Recipient may be sent via email to the email address
				identified in Recipient&apos;s user account, if applicable, as evidenced by a digital record of such
				transmission, which Notice shall be effective as of the date of transmission.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				11. <strong style={{ textDecoration: 'underline' }}>Other Terms.</strong> Use of the Company&apos;s
				Website, any services provided pursuant thereto, and any Data Room or other software controlled by the
				Company is subject at all times to the Company&apos;s Terms of Use (
				<strong>&quot;Terms of Use&quot;</strong>
				), available at{' '}
				<Link
					underline="hover"
					target="_blank"
					rel="noreferrer"
					href="https://www.cerebrocapital.com/terms-of-use/"
				>
					https://www.cerebrocapital.com/terms-of-use/
				</Link>
				, as updated from time to time, as well as any other agreements between the Company and the co-signatory
				hereto.
			</CerebroText>
			<CerebroText variant="small" sx={{ marginBottom: 1.5 }}>
				12. <strong style={{ textDecoration: 'underline' }}>Miscellaneous.</strong> This Agreement is the entire
				agreement of the parties regarding its subject matter, and supersedes all prior and contemporaneous
				understandings, agreements, representations, and warranties, whether written or oral, regarding such
				subject matter. This Agreement may only be amended, modified, waived, or supplemented by an agreement in
				writing signed by both parties. If any provision of this Agreement shall be held to be invalid, illegal
				or unenforceable, in whole or in part, neither the validity of the remaining parts of such provision nor
				the validity of any other provisions of this Agreement shall in any way be affected, so long as the
				essential rights and obligations of the parties under this Agreement are preserved. This Agreement and
				the rights and obligations hereunder are not transferable or assignable by either party; provided,
				however, that the Company may freely assign this Agreement in connection with a change in control or the
				sale of all or substantially all of its assets.
			</CerebroText>
		</>
	);
};
